export default __webpack_public_path__ + "static/media/emailCustomization-black.ef9b46c5.svg";